import { fetchApi } from '../api/digitalVault';
import { parseFiles, parseFolders } from '../utils';
/*
  Used for simple checking if file/folder exists - if 404 error it doesn't exist
  It can also  be used to fetch single file or folder with standard params and no pagination
 */
const getUserFileOrFolder = async (params, repository, type, logger) => {
    const result = await fetchApi(params, `repository/${repository}/${type}`, {}, false, logger);
    const data = type === 'folder' ? parseFolders(result)[0] : parseFiles(result)[0];
    return data;
};
export default getUserFileOrFolder;
